import { createContext, useState } from "react";

export type FlowStep =
  | typeof FlowStep.ITEMS
  | typeof FlowStep.REVIEW
  | typeof FlowStep.CONFIRMATION;

export namespace FlowStep {
  export const ITEMS = Symbol("items");
  export const REVIEW = Symbol("review");
  export const CONFIRMATION = Symbol("confirmation");
}

// If the user chooses "Returning a gift" we fill this data in to store their data.
const FlowStepContext = createContext({
  flowStep: FlowStep.ITEMS as FlowStep,
  setFlowStep: (flowStep: FlowStep) => {},
  submitting: false,
  setSubmitting: (submitting: boolean) => {},
});

const FlowStepContextProvider = ({ children }) => {
  const [flowStep, setFlowStep] = useState<FlowStep>(FlowStep.ITEMS);
  const [submitting, setSubmitting] = useState(false);

  return (
    <FlowStepContext.Provider
      value={{
        flowStep,
        setFlowStep,
        submitting,
        setSubmitting,
      }}
    >
      {children}
    </FlowStepContext.Provider>
  );
};

export { FlowStepContext, FlowStepContextProvider };
